const Ajv = require('ajv');
const ajv = new Ajv({ allErrors: true, jsonPointers: true });
require('ajv-errors')(ajv /*, {singleError: true} */);

const validate = (schema, validationInfo) => {
    const errors = [];
    const valid = ajv.validate(schema, validationInfo);
    if (!valid) {
        errors.push(...ajv.errors);
    }
    return { isValid: valid, errors };
};

const validateTemplateOptions = (templateOptions) => {
    let allValid = true;

    for (let optKey in templateOptions) {
        if (templateOptions.hasOwnProperty(optKey)) {
            let optList = templateOptions[optKey];
            optList.forEach(opt => {
                opt.error = null; // reset any old error
                if (opt.schema && !opt.secret) {
                    let {isValid, errors} = validate(opt.schema, opt.value);
                    if (!isValid) {
                        allValid = false;
                        opt.error = errors[0].message;
                    }
                }
            });
        }
    }
    return allValid;
};

export {
    validate,
    validateTemplateOptions
};



// WEBPACK FOOTER //
// ./src/utils/validator.js